import { TransferModel } from 'api-hooks/transactions/transfer';
import React from 'react';

import { TransferFormType } from '../components/form-type';

export default function useGetDefaultValues(transfer?: TransferModel) {
  const defaultValues = React.useMemo<TransferFormType>(() => {
    return {
      transactionAt: transfer?.transactionAt || new Date(),
      tempTransactionAt: transfer?.transactionAt || new Date(),
      needApproval: false,
      amount: transfer?.amount || 0,
      description: transfer?.description || '',
      fromAccountType: transfer?.fromAccountType || null,
      fromAccountable: transfer?.fromAccountable.id || null,
      toAccountType: transfer?.toAccountType || null,
      toAccountable: transfer?.toAccountable.id || null,
      number: transfer?.number || '',
      refId: transfer?.refId,
    };
  }, [transfer]);

  return defaultValues;
}
